import React from "react";
import { motion } from "framer-motion";
import SpaceCard from "./SpaceCard";

const GridView = ({
  spaces,
  onSelectSpace,
  onBookSpace,
  onEdit,
  onDelete,
  onTogglePublish,
  onToggleFeatured,
  onHostClick,
}) => {
  return (
    <motion.div
      className="grid grid-cols-1 gap-4 sm:gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 pb-12 w-full max-w-full"
      initial="hidden"
      animate="visible"
      variants={{
        hidden: { opacity: 0 },
        visible: {
          opacity: 1,
          transition: {
            staggerChildren: 0.06,
            delayChildren: 0.04,
          },
        },
      }}
    >
      {spaces.map(space => (
        <motion.div
          key={space.id}
          variants={{
            hidden: { opacity: 0, y: 24, scale: 0.97 },
            visible: {
              opacity: 1,
              y: 0,
              scale: 1,
              transition: { type: "spring", stiffness: 300, damping: 24 },
            },
          }}
        >
          <SpaceCard
            space={space}
            status={space.status}
            onClick={() => onSelectSpace && onSelectSpace(space)}
            onBookSpace={onBookSpace}
            onEdit={onEdit}
            onDelete={onDelete}
            onTogglePublish={onTogglePublish}
            onToggleFeatured={onToggleFeatured}
            onHostClick={onHostClick}
          />
        </motion.div>
      ))}
    </motion.div>
  );
};

export default GridView;
